// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"b0848c39","117":"5803798e","161":"3297cf9d","209":"32193747","248":"e62fa093","478":"ffce1e4e","625":"c5227c16","745":"4cdb9fc4","922":"a9748d02","964":"763e6f1c"}[chunkId] + ".chunk.js";
};